/**
 * The states an adviser can be in on the public registry: validated, or attested on top of that.
 * The registry carries no other — an adviser still under review never leaves the cabinet.
 */
export const PUBLIC_ADVISOR_STATUS = {
  validated: 'VALIDATED',
  attested: 'ATTESTED',
} as const;
